import React from "react";
import { Radio } from "antd";
import { useHistory } from "react-router-dom";

function TabMenu(props) {
  let history = useHistory();

  const handleMenuChange = (e) => {
    history.push(`/stock-issue/${props.id}/${e.target.value}`);
  };

  return (
    <div>
      <Radio.Group
        value={props.menu}
        onChange={handleMenuChange}
        style={{ marginBottom: 10 }}
      >
        <Radio.Button value="summary" style={{ marginRight: 5 }}>
          Summary
        </Radio.Button>
        {/* <Radio.Button value="grn" style={{ marginRight: 5 }}>
          GRN Details
        </Radio.Button> */}
        <Radio.Button value="asycuda" style={{ marginRight: 5 }}>
          Asycuda
        </Radio.Button>
        <Radio.Button value="history" style={{ marginRight: 5 }}>
          History
        </Radio.Button>
        {/* <Radio.Button value="grn" style={{ marginRight: 5 }}>
          GRN Details
        </Radio.Button> */}
        <Radio.Button value="documents" style={{ marginRight: 5 }}>
          Documents
        </Radio.Button>

        <Radio.Button value="write-off" style={{ marginRight: 5 }}>
          Write-Off
        </Radio.Button>
        {/* <Radio.Button value="transactions" style={{ marginRight: 5 }}>
          Transactions
        </Radio.Button> */}
      </Radio.Group>
    </div>
  );
}

export default TabMenu;
